import React from "react";
import { Tab, Card, Spinner, Modal, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getShiftApi } from "../../services/TransportService";
import { updateShiftApi } from "../../services/TransportService";
import { toast } from "react-toastify";
import { format, parse } from "date-fns";
import { convertTo12HourFormats } from "../../utilities";
const convertTo24HourFormat = (time) => {
  const [hours, minutesWithPeriod] = time.split(":");
  const [minutes, period] = minutesWithPeriod.split(" ");
  let convertedHours = parseInt(hours);

  if (period === "PM" && convertedHours !== 12) {
    convertedHours += 12; // Convert PM to 24-hour format
  } else if (period === "AM" && convertedHours === 12) {
    convertedHours = 0; // Convert 12 AM to 00
  }

  // Format to HH:mm
  return `${String(convertedHours).padStart(2, "0")}:${minutes}`;
};

const Shiftdetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [errormessage, setErrormessage] = useState("");
  const handleToggleModal = () => {
    if (!modalVisible) {
      setErrormessage("");
      setFormdata({
        name: data?.name || "",
        start_time: data.start_time
          ? convertTo24HourFormat(data.start_time)
          : "",
        end_time: data.end_time ? convertTo24HourFormat(data.end_time) : "",
        drop_start_time: data.drop_start_time
          ? convertTo24HourFormat(data.drop_start_time)
          : "",
        drop_end_time: data.drop_end_time
          ? convertTo24HourFormat(data.drop_end_time)
          : "",
      });
      setFormerror({
        name: "",
        start_time: "",
        end_time: "",
        drop_start_time: "",
        drop_end_time: "",
      });
    }
    setModalVisible((prev) => !prev);
  };
  const [formdata, setFormdata] = useState({
    name: "",
    start_time: "",
    end_time: "",
    drop_start_time: "",
    drop_end_time: "",
  });
  const [fromError, setFormerror] = useState({
    name: "",
    start_time: "",
    end_time: "",
    drop_start_time: "",
    drop_end_time: "",
  });
  const getdata = () => {
    getShiftApi(id)
      .then((res) => {
        // Log the response to verify the data structure

        setData(res?.data); // This sets the data into stat
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getdata();
  }, [id]);
  const updateshift = (payload) => {
    setLoading(true);
    updateShiftApi(id, payload)
      .then((res) => {
        toast.success("Update Successfully");
        handleToggleModal();
      })
      .catch((err) => {
        setErrormessage(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Please try again later"
        );
      })
      .finally(() => {
        setLoading(false);
        getdata();
      });
  };
  const columns = [
    {
      name: "Number Plate",
      selector: (row) => (
        <>
          <span
            className="text-primary fw-semibold cursor-pointer"
            onClick={() => navigate(`/bus/${row?.id}`)}
          >
            {row?.number_plate}
          </span>
          <span> ({row?.model})</span>
        </>
      ),
      wrap: true,
      grow: 2,
    },
    {
      name: "Capacity",
      selector: (row) => row.capacity,
      wrap: true,
    },
    {
      name: "Occupied",
      selector: (row) => row.occupied,
      wrap: true,
    },
    {
      name: "Available Seats",
      selector: (row) => row.available_seats,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.is_active,
      cell: (row) => (
        <span
          className={`badge ${row.is_active ? "bg-success" : "bg-secondary"}`}
        >
          {row.is_active ? "Active" : "Inactive"}
        </span>
      ),
      wrap: "true",
    },
  ];
  const handlesubmit = () => {
    let isValid = true;
    const newErrors = {};

    if (!formdata.name) {
      newErrors.name = "Mandatory Field";
      isValid = false;
    }

    if (!formdata.start_time) {
      newErrors.start_time = "Mandatory Field";
      isValid = false;
    }

    if (!formdata.end_time) {
      newErrors.end_time = "Mandatory Field";
      isValid = false;
    }
    if (!formdata.drop_start_time) {
      newErrors.drop_start_time = "Mandatory Field";
      isValid = false;
    }

    if (!formdata.drop_end_time) {
      newErrors.drop_end_time = "Mandatory Field";
      isValid = false;
    }

    setFormerror(newErrors);

    if (isValid) {
      updateshift(formdata);
      // proceed with form submission
    }
  };
  return (
    <div>
      {/* <Tab.Container defaultActiveKey="tabOne">
        <Block className="mt-2">
          <Tab.Content>
            <Tab.Pane eventKey="tabOne">
              <Card className="card-gutter-md">
                <div className="card-row card-row-lg col-sep col-sep-lg">
                  <div className="card-aside">
                    <Card.Body>
                      <div className="bio">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm btn-circle"
                              onClick={() => navigate("/shifts")}
                            >
                              <Icon name="arrow-left"></Icon>
                            </button>
                            <h4 className="bio-block-title mx-3">
                              Shift Details
                            </h4>
                          </div>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={handleToggleModal}
                          >
                            <Icon name="edit" />
                            <span>Edit</span>
                          </Button>
                        </div>

                        <ul className="list-group list-group-borderless small mt-2">
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Name:
                            </span>
                            <span className="text">{data?.name}</span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Pickup Time:
                            </span>
                            <span className="text">
                              (
                              {data?.start_time
                                ? convertTo12HourFormats(data.start_time)
                                : "N/A"}{" "}
                              -{" "}
                              {data?.end_time
                                ? convertTo12HourFormats(data.end_time)
                                : "N/A"}
                              )
                            </span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Drop Time:
                            </span>
                            <span className="text">
                              (
                              {data?.drop_start_time
                                ? convertTo12HourFormats(data.drop_start_time)
                                : "N/A"}{" "}
                              -{" "}
                              {data?.drop_end_time
                                ? convertTo12HourFormats(data?.drop_end_time)
                                : "N/A"}
                              )
                            </span>
                          </li>
                        </ul>
                      </div>

                    
                    </Card.Body>
                  </div>
                 
                  <div className="card-content col-sep flex-fill">
                    <Card.Body className="p-0">
                      <div className="border-bottom px-3 py-2">
                        <h4>Active Buses</h4>
                      </div>

                      {!data?.active_buses || data.active_buses.length === 0 ? (
                        <div className="p-2 text-center">
                          There are no records found.
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table fs-6 align-middle mb-0">
                            <thead className="custom-thead table-light">
                              <tr>
                                <th>Number Plate</th>
                                <th>Capacity</th>
                                <th>Occupied</th>
                                <th>Available Seats</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.active_buses.map((row, index) => (
                                <tr key={index}>
                                  <td>
                                    <span
                                      className="text-primary fw-semibold cursor-pointer"
                                      onClick={() =>
                                        navigate(`/bus/${row?.id}`)
                                      }
                                    >
                                      {row?.number_plate}
                                    </span>
                                    <span> ({row?.model})</span>
                                  </td>
                                  <td>{row.capacity}</td>
                                  <td>{row.occupied}</td>
                                  <td>{row.available_seats}</td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        row.is_active
                                          ? "bg-success"
                                          : "bg-secondary"
                                      }`}
                                    >
                                      {row.is_active ? "Active" : "Inactive"}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </Card.Body>
                  </div>
                </div>
              </Card>
            </Tab.Pane>
          </Tab.Content>
        </Block>
      </Tab.Container> */}
      <div className="card">
        <div className="row px-2">
          <div className="col-12 col-md-4 border-end p-4">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm btn-circle"
                  onClick={() => navigate("/shifts")}
                >
                  <Icon name="arrow-left"></Icon>
                </button>
                <h4 className="bio-block-title mx-3">Shift Details</h4>
              </div>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={handleToggleModal}
              >
                <Icon name="edit" />
                <span>Edit</span>
              </Button>
            </div>

            <ul className="list-group list-group-borderless small mt-2">
              <li className="list-group-item">
                <span className="title fw-medium w-40 d-inline-block">
                  Name:
                </span>
                <span className="text">{data?.name}</span>
              </li>
              <li className="list-group-item">
                <span className="title fw-medium w-40 d-inline-block">
                  Pickup Time:
                </span>
                <span className="text">
                  (
                  {data?.start_time
                    ? convertTo12HourFormats(data.start_time)
                    : "N/A"}{" "}
                  -{" "}
                  {data?.end_time
                    ? convertTo12HourFormats(data.end_time)
                    : "N/A"}
                  )
                </span>
              </li>
              <li className="list-group-item">
                <span className="title fw-medium w-40 d-inline-block">
                  Drop Time:
                </span>
                <span className="text">
                  (
                  {data?.drop_start_time
                    ? convertTo12HourFormats(data.drop_start_time)
                    : "N/A"}{" "}
                  -{" "}
                  {data?.drop_end_time
                    ? convertTo12HourFormats(data?.drop_end_time)
                    : "N/A"}
                  )
                </span>
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-8 p-0">
            <div className="border-bottom px-3 py-2">
              <h4>Active Buses</h4>
            </div>

            {!data?.active_buses || data.active_buses.length === 0 ? (
              <div className="p-2 text-center">There are no records found.</div>
            ) : (
              <div className="table-responsive">
                <table className="table fs-6 mb-0">
                  <thead className="custom-thead table-light">
                    <tr>
                      <th>Number Plate</th>
                      <th>Capacity</th>
                      <th>Occupied</th>
                      <th>Available Seats</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.active_buses.map((row, index) => (
                      <tr key={index}>
                        <td>
                          <span
                            className="text-primary fw-semibold cursor-pointer"
                            onClick={() => navigate(`/bus/${row?.id}`)}
                          >
                            {row?.number_plate}
                          </span>
                          <span> ({row?.model})</span>
                        </td>
                        <td>{row.capacity}</td>
                        <td>{row.occupied}</td>
                        <td>{row.available_seats}</td>
                        <td>
                          <span
                            className={`badge ${
                              row.is_active ? "bg-success" : "bg-secondary"
                            }`}
                          >
                            {row.is_active ? "Active" : "Inactive"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={modalVisible}
        onHide={handleToggleModal}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Shift</Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-4">
          <div className="row">
            {errormessage && (
              <div className="alert alert-danger col-12">{errormessage}</div>
            )}
            <div className="col-12">
              <label className="form-label">Shift Name</label>
              <input
                type="text"
                placeholder="Shift Name"
                className={`form-control${fromError.name ? " is-invalid" : ""}`}
                name="name"
                onChange={(e) =>
                  setFormdata({ ...formdata, name: e.target.value })
                }
                value={formdata.name}
              />
              {fromError.name && (
                <small className="text-danger">{fromError.name}</small>
              )}
            </div>
            <div className="col-6 mt-2">
              <label className="form-label">Pickup Start Time</label>
              <input
                type="time"
                placeholder="Time"
                className={`form-control${
                  fromError.start_time ? " is-invalid" : ""
                }`}
                name="start_time"
                onChange={(e) =>
                  setFormdata({ ...formdata, start_time: e.target.value })
                }
                value={formdata.start_time}
              />
              {fromError.start_time && (
                <small className="text-danger">{fromError.start_time}</small>
              )}
            </div>
            <div className="col-6 mt-2">
              <label className="form-label">Pickup End Time</label>
              <input
                type="time"
                placeholder="Time"
                className={`form-control${
                  fromError.end_time ? " is-invalid" : ""
                }`}
                name="end_time"
                onChange={(e) =>
                  setFormdata({ ...formdata, end_time: e.target.value })
                }
                value={formdata.end_time}
              />
              {fromError.end_time && (
                <small className="text-danger">{fromError.end_time}</small>
              )}
            </div>
            <div className="col-6 mt-2">
              <label className="form-label">Drop Start Time</label>
              <input
                type="time"
                placeholder="Time"
                className={`form-control${
                  fromError.drop_start_time ? " is-invalid" : ""
                }`}
                name="start_time"
                onChange={(e) =>
                  setFormdata({ ...formdata, drop_start_time: e.target.value })
                }
                value={formdata.drop_start_time}
              />
              {fromError.drop_start_time && (
                <small className="text-danger">
                  {fromError.drop_start_time}
                </small>
              )}
            </div>
            <div className="col-6 mt-2">
              <label className="form-label">Drop End Time</label>
              <input
                type="time"
                placeholder="Time"
                className={`form-control${
                  fromError.drop_end_time ? " is-invalid" : ""
                }`}
                name="end_time"
                onChange={(e) =>
                  setFormdata({ ...formdata, drop_end_time: e.target.value })
                }
                value={formdata.drop_end_time}
              />
              {fromError.drop_end_time && (
                <small className="text-danger">{fromError.drop_end_time}</small>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            //   disabled={isAddSubmiting}
            onClick={handleToggleModal}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            //   disabled={isAddSubmiting}
            onClick={handlesubmit}
            disabled={loading}
          >
            {loading && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            Update{" "}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Shiftdetails;
